<template>
    <div>
        <el-table
            ref="multipleTable"
            class="right-content"
            :data="tableData"
            :height="480"
            :row-class-name="tableRowClassName"
            border
            @selection-change="handleSelectionChange"
        >
            <el-table-column
                type="selection"
                width="40">
            </el-table-column>
            <el-table-column  type="expand">
                <template slot-scope="props">
                   <table-content
                        ref="tableContent"
                        :contentTableData="props.row"
                    ></table-content>
                </template>
            </el-table-column>
            <el-table-column
                show-overflow-tooltip
                v-for="(item, index) in rightColumnsListConfig"
                :key="index"
                :prop="item.prop"
                :label="item.label"
                :width="item.width"
            >
            </el-table-column>
             <el-table-column
                label="操作"
                align="center"
                width="80">
                <template slot-scope="scope">
                    <el-button @click="handleClick(scope.row)" type="text" size="small">商品明细</el-button>
                </template>
                </el-table-column>
        </el-table>
        <div class="summarizing">
            <span>共 {{ selectedRowsData.length }} 项</span>
        </div>
        <inventory-dialog
            v-if="dialogVisible"
            :dialogVisible.sync="dialogVisible"
            :rowData="rowData"
        ></inventory-dialog>
    </div>

</template>
<script>
import { rightColumnsListConfig } from './tableContentConfig';
import InventoryDialog from './InventoryDialog';
import tableContent from './tableContent';

export default {
    components: { InventoryDialog, tableContent },
    props: {
        contentTableData: {
            type: Array,
            default () {
                return [];
            }
        }
    },
    data () {
        return {
            loading: false,
            dialogVisible: false,
            rightColumnsListConfig,
            tableData: [],
            selectedRowsData: [],
            rowData: {}
        };
    },
    computed: {

    },
    watch: {
        contentTableData: {
            handler (newVal, oldVal) {
                this.tableData = newVal;
                this.$nextTick(() => {
                    this.tableData.forEach(item => {
                        this.$refs.multipleTable.toggleRowSelection(item, true);
                    });
                });
            },
            deep: true,
            immediate: true
        }
    },
    methods: {
        tableRowClassName ({ row }) {
            if (this.selectedRowsData.includes(row)) {
                return 'highlight-row';
            }
        },
        handleClick (rowData) {
            this.rowData = rowData;
            this.dialogVisible = true;
        },
        handleSelectionChange (val) {
            this.selectedRowsData = val;
            this.$emit('selectChange', val);
        }
    }
};
</script>
<style lang="less">
.right-content{
    .el-table__expanded-cell{
        padding: 0px 0px 0px 40px !important;
    }
}

</style>
